<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Detalhes do Benefício") }}</h1>

        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <div id="boxPrint" class="row">
            <div class="col-md-12">
                <print-header></print-header>
                <Page
                    titulo="RECIBO DE CONCESSÃO DO BENEFÍCIO"
                    :item="item"
                    text-footer="ASSINATURA"
                    :wpp="wpp"
                    :email="email"
                />

                <Page
                    class="mt-5"
                    titulo="AUTORIZAÇÃO  DE CONCESSÃO DO BENEFÍCIO"
                    :item="item"
                    text-footer="AUTORIZADO"
                    :wpp="wpp"
                    :email="email"
                />

                <div class="row pt-4 px-0 d-flex justify-content-end no-print">
                    <div class="col-auto px-2 text-right">
                        <form-toggle
                            grid="12"
                            mt="0"
                            v-model="email"
                            label="Email"
                        />
                        <form-toggle
                            grid="12"
                            mt="0"
                            v-model="wpp"
                            label="Telefone/WhatsApp"
                        />
                        <router-link
                            :to="`/dashboard/familia/beneficio/edit/${item.id}`"
                            class="btn btn-default"
                        >
                            <i class="mdi mdi-arrow-left" />
                        </router-link>

                        <a class="btn btn-sm py-1 btn-primary" @click="print()">
                            <i class="mdi mdi-printer mdi-18px" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Page from "./includes/ShowContent";
export default {
    name: "Show",
    components: { Page },
    data() {
        return {
            loading: true,
            item: {},
            app_cidade: this.$store.state.settings.app_cidade,
            app_data_atual: this.$store.state.settings.app_data_atual,
            servicos: [],
            unidades: [],
            rota_anterior: null,
            wpp: true,
            email: true
        };
    },
    mounted() {
        this.getBeneficios();
        this.getBeneficio();
    },
    methods: {
        getBeneficios() {
            axios.get(`api/dashboard/get/beneficios`).then((response) => {
                this.beneficios = response.data;
            });
        },
        getBeneficio() {
            this.loading = true;
            var id = this.is_morph
                ? this.morphbeneficioId
                : this.$route.params.id;
            axios
                .get(`api/dashboard/familia/beneficio/${id}`)
                .then((response) => {
                    this.item = response.data.data;
                    // this.$route.query.familia_id = this.beneficio.familia_id;
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "O item não foi carregado corretamente<br>" + error,
                        icon: "error",
                    });
                });
        },
        getValue(value, array) {
            const result = array.filter((item) => item.id == value);
            return result[0] ? result[0].value : "";
        },
    },
};
</script>
<style>
.router-link-exact-active {
    cursor: pointer;
}
</style>
